import React from 'react'
import Starterpicimg from "./starterPic.jpg"

export default function Startepic() {
  return (
    <img id="starterImg" className = "h-96 m-auto md:mr-32 xl:mr-64 2xl:mr-96 rounded-lg" src={Starterpicimg}></img>
  )
}
